import { Controller, useFormState } from 'react-hook-form';
import { ICommonFormProps } from '@src/components/DynamicForm';
import { FormLabel, MultiSelect, SingleSelect } from '@src/components/ui';
import { useSelectZone } from './hooks';

export const FormSelectZone = (props: Readonly<ICommonFormProps>) => {
    const {
        label,
        keyName,
        control,
        className,
        registerOptions,
        formProps,
        inputProperties,
        disabled,
    } = props;

    const {
        options,
        hasMore,
        isLoading,
        isFetching,
        fetchZones,
        loadMore,
        resetSearch,
    } = useSelectZone(formProps?.type, disabled);

    const { touchedFields, isSubmitted } = useFormState({ control });

    return (
        <div className={className}>
            <Controller
                control={control}
                name={keyName}
                render={({ field, fieldState: { error: fieldStateError } }) => {
                    // Use filtered errors prop if available, otherwise use fieldState error
                    // But only show if field has been touched or form submitted
                    const error = props.errors ?? fieldStateError;
                    const showError = Boolean(
                        error && (touchedFields[keyName] || isSubmitted)
                    );
                    const handleChange = (val: any) => {
                        if (formProps?.isMulti) {
                            field.onChange(val ?? []);
                        } else {
                            field.onChange(val ?? null);
                        }
                        field.onBlur();
                    };
                    return (
                        <>
                            {label && (
                                <FormLabel
                                    label={label}
                                    required={
                                        typeof registerOptions?.required ===
                                        'object'
                                            ? Boolean(
                                                  registerOptions.required.value
                                              )
                                            : Boolean(registerOptions?.required)
                                    }
                                />
                            )}

                            {formProps?.isMulti ? (
                                <MultiSelect
                                    field={{ ...field, onChange: handleChange }}
                                    options={options}
                                    hasMore={hasMore}
                                    loadMore={loadMore}
                                    loading={isLoading || isFetching}
                                    placeholder={
                                        inputProperties?.placeholder ??
                                        'Select zones'
                                    }
                                    allowClear={formProps?.allowClear}
                                    onSearch={fetchZones}
                                    onClear={() => resetSearch()}
                                    disabled={disabled}
                                />
                            ) : (
                                <SingleSelect
                                    field={{ ...field, onChange: handleChange }}
                                    options={options}
                                    hasMore={hasMore}
                                    loadMore={loadMore}
                                    loading={isLoading || isFetching}
                                    placeholder={
                                        inputProperties?.placeholder ??
                                        'Select a zone'
                                    }
                                    allowClear={formProps?.allowClear}
                                    onSearch={fetchZones}
                                    onClear={() => resetSearch()}
                                    disabled={disabled}
                                />
                            )}

                            {showError && error?.message && (
                                <div className="text-red-500 text-sm mt-0">
                                    {error.message}
                                </div>
                            )}
                        </>
                    );
                }}
            />
        </div>
    );
};
